"use strict";

exports.__esModule = true;
exports.default = void 0;
/**
 * Helper to normalize a theme variable (defined in ems) against the applied
 * fontSize (also defined in ems), so that the resulting value renders correctly
 */

var getNormalizedValue = function getNormalizedValue(value, base) {
  return parseFloat(value) / parseFloat(base) + "em";
};

var _default = getNormalizedValue;
exports.default = _default;